<!-->┌────┬─────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│ PA │                            Pagination Component                                 │<- ->
<- ->└────┴─────────────────────────────────────────────────────────────────────────────────┘<--->
<style scoped lang="less" src=":/PA/styles/pagination.less"></style>

<script>
    import Pagination from "@/common/pagination"
    export default {
        ...Pagination,
        name: "Pagination.PA"
    }
</script>
